import { ChartDef } from '@model-main/pivot/frontend/model/chart-def';

export const RegressionTypes = {
    LINEAR: ChartDef.RegressionType.LINEAR,
    POLYNOMIAL: ChartDef.RegressionType.POLYNOMIAL,
    EXPONENTIAL: ChartDef.RegressionType.EXPONENTIAL,
    LOGARITHMIC: ChartDef.RegressionType.LOGARITHMIC
}
